
import { CoinbaseWallet } from '@web3-react/coinbase-wallet'
import { initializeConnector } from '@web3-react/core'
import { URLS } from './chains'

import {useEffect} from "react";


const [coinbaseWallet, hooks] = initializeConnector<CoinbaseWallet>(
    (actions) =>
        new CoinbaseWallet(actions, {
            url: URLS[1][0],
            appName: 'web3-react',
        })
)


const { useAccounts} = hooks;

interface InitProps {
    connect: boolean;
    onAddressChange: (address: string[] | undefined) => void;
}

function CoinBaseWallet(props: InitProps) {

    const accounts = useAccounts()



    useEffect(() => {
        const connect = async () => {
            await coinbaseWallet.connectEagerly()
        }

        connect();
    }, [])


    useEffect(() => {

        if (accounts) {
            props.onAddressChange(accounts);

            // setTimeout(() => {
            //     coinbaseWallet.deactivate();
            // }, 5000)

        }

    }, [accounts])

    useEffect(() => {

        if (props.connect)  {

            const activate = async () => {
                await coinbaseWallet.activate();

                await coinbaseWallet.connectEagerly()


            }

            activate();

        }


    }, [props.connect])


    return <></>

}

export default CoinBaseWallet;
